<template>
    <v-container class="form-container">
           
        <v-layout justify-center="" class="form-details">
          <v-flex xs12>
        <v-form v-model="valid">
            <div v-for="(item, index) in form.content.template.fields" :key="index">
            <v-text-field
            v-if="item.type == 'text'"
            :label="item.question"
            v-model="form.content.details[item.field]"
            :required="item.required"
            :rules="rules(item.required)"
            :disabled="true"
            >
            </v-text-field>

            <v-textarea
            v-if="item.type == 'textarea'"
            :label="item.question"
            v-model="form.content.details[item.field]"
            :required="item.required"
            :rules="[roels.length]"
            :disabled="true"

            >
            </v-textarea>

            <v-switch
            v-if="item.type == 'switch'"
            color="green"
            :label="item.question"
            v-model="form.content.details[item.field]"
            :disabled="true"

            >
            </v-switch>

            <v-select
            v-if="item.type == 'select'"
            :items="item.options"
            :label="item.question"
            v-model="form.content.details[item.field]"
            :disabled="true"
            >
            </v-select>
            </div>
            </v-form>
          </v-flex>
        </v-layout>

        <v-layout justify-center="" class="pb-4">
            <v-flex xs8>
            <v-btn block rounded color="success" :disabled="!valid" @click="applyForm()">
                Formulier verwerken
            </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      active: null,
      valid: false,
      len: 50,
      roels: {
        length: v => (v || "").length <= 250 || `Maximaal 250 karakters`
      }
    };
  },
  methods: {
    ...mapActions(["applyForm"]),
    rules(required) {
      if (required) {
        return [v => !!v || "Verplicht veld"];
      } else {
        return null;
      }
    }
  },
  computed: {
    ...mapState(["app", "form"])
  },
  created() {
    this.$store.dispatch("checkAuth");
  }
};
</script>

<style>
.form-container {
  padding-top: 60px;
}
</style>

